import React from "react";


export function HighlightRow({ title, data }) {
    return (
        <div className="flex items-center gap-x-3 subHeadingText text-coalBlack">
            <p>{title}</p>
            <p className="ms-auto">
                {data}
            </p>
        </div>
    )
}

export function LightRow({ title, data, loopdata, type }) {
    const specializations = loopdata?.[type]?.specializations;

    return (
        <div className="space-y-2 pb-2 border-b border-gray-200 border-dotted">
            <div className="flex items-center gap-x-3 baseText text-coalBlack">
                <p>{title}</p>
                <p className="ms-auto">{data}</p>
            </div>

            {specializations && (
                Object.entries(specializations).map(([specialization, count]) => (
                    <div
                        key={specialization}
                        className="flex items-center gap-x-3 baseText text-coalBlack capitalize"
                    >
                        <p className="text-navLink">{specialization}</p>
                        <p className="ms-auto text-navLink">{count}</p>
                    </div>
                ))
            )}
        </div>
    );
}

